// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__XZCyo","scrollableBody":"Modal_scrollableBody__eW+Ns"};